// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__2oKTQ","is-full-width":"Tooltip_is-full-width__Bk9Vl"};